import { api } from "./client";

export interface AdminUserListItem {
  id: number;
  username: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  designation: string | null;
  status: number;
  type: number;
  created_at: string;
  updated_at: string;
}

export interface AdminUserListPage {
  items: AdminUserListItem[];
  total: number;
  page: number;
  page_size: number;
}

export interface AdminUserDetail extends AdminUserListItem {
  phone: string | null;
  web: string | null;
  address: string | null;
  profile: string | null;
  card_logo: string | null;
  about_text: string | null;
  video_heading: string | null;
  about_heading: string | null;
  video_url: string | null;
  has_pending_email_verification: boolean;
  password_hash_prefix: string;
}

export interface AdminStats {
  total: number;
  active: number;
  inactive: number;
  deleted: number;
  admins: number;
  pending_approval: number;
}

export interface AdminUserCreate {
  username: string;
  email: string;
  password: string;
  first_name?: string | null;
  last_name?: string | null;
  designation?: string | null;
}

export interface AdminPasswordSet {
  new_password: string;
}

export interface AdminUserUpdate {
  status?: number;
  type?: number;
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  web?: string | null;
  address?: string | null;
  designation?: string | null;
  profile?: string | null;
  card_logo?: string | null;
  about_text?: string | null;
  video_heading?: string | null;
  about_heading?: string | null;
  video_url?: string | null;
}

export async function getStats() {
  return api.get<AdminStats>("/admin/stats");
}

export async function listUsers(params: {
  search?: string;
  status?: number;
  type?: number;
  page?: number;
  page_size?: number;
} = {}) {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== "") qs.append(k, String(v));
  }
  return api.get<AdminUserListPage>(`/admin/users${qs.toString() ? `?${qs}` : ""}`);
}

export async function getUser(id: number) {
  return api.get<AdminUserDetail>(`/admin/users/${id}`);
}

export async function updateUser(id: number, payload: AdminUserUpdate) {
  return api.put<AdminUserDetail>(
    `/admin/users/${id}`,
    payload as unknown as Record<string, unknown>,
  );
}

export async function softDeleteUser(id: number) {
  return api.delete<AdminUserDetail>(`/admin/users/${id}`);
}

export async function restoreUser(id: number) {
  return api.post<AdminUserDetail>(`/admin/users/${id}/restore`);
}

export async function rotateAuthKey(id: number) {
  return api.post<AdminUserDetail>(`/admin/users/${id}/rotate-auth-key`);
}

export async function approveUser(id: number) {
  return api.post<AdminUserDetail>(`/admin/users/${id}/approve`);
}

export async function createUser(payload: AdminUserCreate) {
  return api.post<AdminUserDetail>(
    "/admin/users",
    payload as unknown as Record<string, unknown>,
  );
}

export async function setPassword(id: number, new_password: string) {
  return api.post<AdminUserDetail>(
    `/admin/users/${id}/set-password`,
    { new_password } as Record<string, unknown>,
  );
}
